import { Popover } from "antd";
import "./chatLike.scss";
import thums from "../../../../styles/images/thumsup.png";
//import icon3 from "../../../../styles/images/icon3.png";
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from "react";
import _ from "lodash";
import { likeCommonFunction, sipCallerId } from "../../../../base/socketChatService/utils";
import { chatwindowDetails, initialStateModel, LoginState } from "../../../../models/model";
import { useSelector } from "react-redux";
import { Cookie } from "../../../../base/utils";
import { SocketChatService } from "../../../../base/socketChatService";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";

type chatLikeProps = {
  message?: any,
  className: string,
  placement: any,
  tooltipTitle: string,
  multiData?: any
}
export default function ChatLike(props: chatLikeProps) {
  let { message, placement, tooltipTitle, className, multiData, ...restProps } = props;
  const { userdetails }: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  let LikeObeject: any = message?.message?.liked || {};
  let likeStore: any = Object.keys(LikeObeject) || [];
  let isLike = (LikeObeject && LikeObeject['s' + userdetails.sip_login_id]) || 0;
  let likeParticipantName: string = '';
  var likeallObj: any = [];
  const chatWindowDetailReducer: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  let { chatWindowDetails } = chatWindowDetailReducer;
  let teamMemberOnly = chatWindowDetails?.team_members
    ? chatWindowDetails?.team_members.split(",").map((ele: any) => ele.trim()) : [];
  const socketChat = useRef<any>(null);
  if (Array.isArray(multiData) && multiData?.length > 0) {
    for (var i = 0; i < multiData.length; i++) {
      let LikeObeject: any = multiData[i]?.message?.liked || {};
      let likeStore: any = Object.keys(LikeObeject) || [];
      for (var j = 0; j < likeStore.length; j++) {
        if (LikeObeject[likeStore[j]] === 1) {
          likeallObj.push({
            userRes: multiData[i],
            likeRes: likeStore[j]
          })
        }
      }
    }
  } else {
    for (var k = 0; k < likeStore.length; k++) {
      if (LikeObeject[likeStore[k]] === 1) {
        likeallObj.push({
          userRes: "",
          likeRes: likeStore[k]
        })
      }
    }
  }



  useEffect(() => {
    const userInfo: any = Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if (userInfosess) {
      const cookieData = JSON.parse(userInfosess);
      socketChat.current = new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
    }
  }, [])
  var isLikeData = _.filter(likeStore, function (data) {
    if (LikeObeject[data] === 1) {
      let nameDetail: any = sipCallerId(data.slice(1).toString()) || [];
      if (likeParticipantName === "") {
        likeParticipantName += nameDetail['caller_id'] || "unknownUser";
      }
      else {
        likeParticipantName += ', ' + nameDetail['caller_id'] || "unknownUser";
      }
      return true;
    }
});
var len = Array.isArray(likeallObj) && likeallObj?.length > 7 ? Math.ceil((likeallObj?.length / 8)) : 1;
var random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
let content:any = (
  <>
    {<div className="popOverContainer">
      <div className="listdrapdrop">
        <ul className="scroller orderItem">
        { Array.isArray(likeallObj) && likeallObj.length>0 && likeallObj?.map((elem: any, index: any) => {
            let nameDetaill: any = sipCallerId(elem.likeRes.slice(1).toString()) || [];
            let ImageURL = nameDetaill?.ImageURL ? nameDetaill.ImageURL : nameDetaill.profile_image_url;
            let likeImg = elem.userRes !== ""?elem.userRes:"";
            let removeImg = elem.userRes !== ""?elem.userRes:message;
            return (
               <li key={index}>
              <div className="likeGroup">
                <div className="userAvatar">
                <URAvatarGroup
                    className={`lefts size38 colorBG${random_color[index]}`}
                    profileInfo={
                      <>
                        {ImageURL ? (
                          <span>
                            <img alt="" src={ImageURL} />
                          </span>
                        ) : (
                          <span>{nameDetaill?.first_name !== undefined ?nameDetaill?.first_name?.charAt(0).toUpperCase()+nameDetaill?.last_name?.charAt(0).toUpperCase() : nameDetaill?.caller_id === undefined ? 'Unknown'?.charAt(0).toUpperCase(): nameDetaill?.caller_id?.charAt(0).toUpperCase()}</span>
                        )}
                      </>
                    }
                  />
                </div>
                <div className="userName">{userdetails.sip_login_id === nameDetaill.sip_login_id ? "You": nameDetaill?.caller_id ? nameDetaill?.caller_id : "Unknown User"}
                {userdetails.sip_login_id === nameDetaill.sip_login_id && ( teamMemberOnly?.includes(userdetails?.sip_login_id?.toString()?.trim()) || chatWindowDetails.sip_login_id )&&
                 <span onClick={()=>likeCommonFunction(isLike === 0 ? 1 : 0, removeImg)} className="removeLike">Click to remove</span>}
                </div>
                {elem.userRes === "" &&  <div className="likeImg"><img src={thums} alt="likeimage" /></div>}
                {elem.userRes !== "" && 
                <div className="likeImgothers">
                  <span className="thumbsicon"><img src={thums} alt="likeimage" /></span>
                  <span className="likedImg"><img src={likeImg?.message.body.filePath} alt="likeimage" /></span>
                </div> }
              </div>  
            </li>
            
            );


            })}
          </ul>
        </div>
      </div>}
    </>
  );
  return (
    <>

      {isLikeData.length !== 0 &&
        <Popover placement="bottomLeft" content={content} overlayClassName="likeDropdown"
          trigger="click">
          <div className={className} {...restProps}>
            <ul>
              {/* <Tooltip mouseEnterDelay={0.5} placement={"top"} title={`${likeParticipantName.replace(userdetails.caller_id, "You")} liked`}
              className='cusTooltip' overlayClassName='toolTipscroller customTooltip '> */}
              <li>
                <div className={isLikeData?.includes('s' + userdetails.sip_login_id) ?
                  `likeImg active` : `likeImg`}>
                  <img className='thumIconPro' src={thums} alt="" />
                  <span>{likeallObj.length}</span>
                </div>
              </li>
            </ul>
          </div>
        </Popover>
      }

    </>
  );
};

ChatLike.propTypes = {
  tooltipTitle: PropTypes.any,
  placement: PropTypes.any,
  className: PropTypes.any
};